import { render } from "./appendix.vue?vue&type=template&id=2807c607"
import script from "./appendix.vue?vue&type=script&lang=js"
export * from "./appendix.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__